import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductExperience } from '../components/ProductExperience';
import { CompetitiveEdge } from '../components/CompetitiveEdge';
import { CaseStudy } from '../components/CaseStudy';
import { LeadershipSection } from '../components/LeadershipSection';
import { FinalCTA } from '../components/FinalCTA';
import { SiteFooter } from '../components/ui/SiteFooter';
export function FemEntityLanding() {
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-514" data-mp="rv1lbwxt2psg">
      {/* Navigation placeholder - minimal for landing page */}
      <nav className="absolute top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto" data-id="element-515" data-mp="my1jxzbwib7o">
        <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-12 md:h-16 drop-shadow-lg" data-id="element-516" data-mp="37mfqq0c4m33g" />
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-517" data-mp="3j134g4yu171o">
          <a href="/get-the-app" className="hover:text-purple-700 transition-colors" data-id="element-518" data-mp="3iyqrk67xlmvh">
            Download the App
          </a>
          <a href="/practitioners" className="hover:text-purple-700 transition-colors" data-id="element-519" data-mp="39z3qjlj46j2y">
            Practitioners
          </a>
        </div>
      </nav>

      <Hero data-id="element-520" data-mp="3038xrxl6f7mg" />
      <ProblemSection data-id="element-521" data-mp="303s7ws4l4rpx" />
      <CaseStudy data-id="element-522" data-mp="304bqmb227k50" />
      <SolutionSection data-id="element-523" data-mp="2masviz03ndml" />
      <ProductExperience data-id="element-524" data-mp="2mblrd4xisipy" />
      <CompetitiveEdge data-id="element-525" data-mp="2mcdo4j2usmht" />
      <LeadershipSection data-id="element-526" data-mp="2m8pvdm58g445" />
      <FinalCTA data-id="element-527" data-mp="2r9nkkiontyf5" />

      <SiteFooter currentPath="/" data-id="element-528" data-mp="2r944l7iklk3r" />
    </main>;
}